module.exports = __webpack_public_path__ + "static/media/fissura_protuso.9f1d91a1.png";